module.exports = "/_next/static/images/sg-6ae2dc5b5c669b14a66f66887faa548f.svg";